import { Component, Input } from '@angular/core';
import { QuestionViewModel } from 'src/app/shared/models/questionview.model';

@Component({
  selector: 'app-input-type-display-text',  
  templateUrl: './input-type-display-text.component.html',
  styleUrl: './input-type-display-text.component.scss'
,  standalone: false
})
export class InputTypeDisplayTextComponent {
  @Input() question: QuestionViewModel;
  @Input() questionIndex: number;
  @Input() totalQuestion: number;
  @Input() showName?: boolean=true;
  @Input() IsReadOnly?:boolean=false;

  ngOnInit() {
    

  }
}




